/**
 * @voltxampere/ui — 4011 quad NAND CMOS variant (Sprint 41-5)
 *
 * Reference: TI CD4011. Engine zero-diff invariant honored —
 * canonical "digital-gate" via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4011 = {
    id: "4011",
    nameTr: "4011 (4'lü NAND CMOS, DIP-14)",
    nameEn: "4011 (Quad NAND CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4011",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NAND",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4011.js.map